import { gql } from "@apollo/client";

export const LIST_CLIENT_VAT_TYPES = gql`
  query listClientVatTypes(
    $filter: ClientVatTypeFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listClientVatTypes(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        code
        editable
      }
    }
  }
`;

export const CREATE_CLIENT_VAT_TYPE = gql`
  mutation createClientVatType($input: CreateClientVatTypeInput!) {
    createClientVatType(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_CLIENT_VAT_TYPE = gql`
  mutation updateClientVatType($input: UpdateClientVatTypeInput!) {
    updateClientVatType(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_CLIENT_VAT_TYPE = gql`
  mutation deleteClientVatType($id: ID!) {
    deleteClientVatType(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_CLIENT_VAT_TYPE = gql`
  query getClientVatType($id: ID!) {
    getClientVatType(id: $id) {
      id
      code
      name
    }
  }
`;
